interface Input {
    hasValidStream: boolean;
    hasValidBetradarId: boolean;
    isMatchTrackerDisabled?: boolean;
}

const checkIsSportEventViewable = ({
    hasValidStream,
    hasValidBetradarId,
    isMatchTrackerDisabled,
}: Input) => {
    return hasValidStream || (hasValidBetradarId && !isMatchTrackerDisabled);
};

export default checkIsSportEventViewable;
